<div class="router-outlet-primary-container main-container" style="height: 100% !important">
    <main class="content-container" style="height: 100% !important">
        <div style="display: flex;">
            <!-- <div *ngIf="!isClientAdmin" class="client-bar">                
                <div class="nickname-block"
                     *ngIf="selectedClient && this.tableDataFiltered && this.tableDataFiltered.length > 0">
                    <div class="nickname-title">Alias:</div>
                    <div *ngIf="isClientMode" class="edit-nickname">
                        <input [value]="ClientAlias" (blur)="editClientNickname(ClientAlias, clientName)" [id]="alias1"
                               class="editable-input" [(ngModel)]="ClientAlias" [ngModelOptions]="{standalone: true}"
                               title="Edit">
                        <span>
                        <button class="link-button mr-2 editable-icon" (click)="editAliasClick(alias1)">
                            <i class="fas fa-edit"></i>
                        </button>
                    </span>
                    </div>
                    <div *ngIf="!isClientMode" class="edit-nickname">
                        <input [value]="selectedNickName" (blur)="editNickname(ClientAlias, selectedClient)"
                               [id]="alias2" class="editable-input" [(ngModel)]="ClientAlias"
                               [ngModelOptions]="{standalone: true}" title="Edit">
                        <span>
                        <button class="link-button mr-2 editable-icon" (click)="editAliasClick(alias2)">
                            <i class="fas fa-edit"></i>
                        </button>
                    </span>
                    </div>
                </div>
            </div> -->
            <form>
                <section class="table-information">
                    <article>
                        <div class="table-filter">
                            <input class="black-input opposite-colors table-search-input search-box-custom" required
                                   placeholder="Type to filter" type="text"
                                   no-special-chars="#!$@%^<>+=" aria-autocomplete="none" aria-expanded="false"
                                   role="search"
                                   (keyup)="searchDataTableFilter($event)"/>
                            <button type="reset" class="cross-icon" (click)="searchDataTableFilter($event)"></button>
                        </div>

                        <div class="buttons-wrapper">
                            <div class="link-button-top-border" (click)="addUser()">
                                <a><i class="fas fa-plus"></i>{{addClientText}}</a>
                            </div>
                            <div class="link-button-top-border" (click)="addBulkUser()"
                                 [class.disable-div-button]="disableBulkClient">
                                <a><i class="fas fa-plus"></i> {{addBulkUserText}}</a>
                            </div>
                        </div>

                        <button class="link-button-top-border-orange" *ngIf="selected && selected.length > 0"
                                (click)="sendDeletionRequest()">
                            <i class="fas fa-trash"></i> Delete Users
                        </button>

                        <button class="link-button-top-border-red"
                                [class.disable-div-button]="disableprovisionFailedUsers" data-toggle="tooltip"
                                title="Click here to retry adding the client users that have failed."
                                *ngIf="isErrorMessage" (click)="provisionFailedUsers()">
                            Retry All Failed Records
                        </button>

                        <div class="table-filter">
                            <ng-container *ngIf="tableDataFiltered">
                                <strong>{{tableDataFiltered.length}}</strong>&nbsp;User<span
                                *ngIf="tableDataFiltered.length !== 1">s</span>
                            </ng-container>
                        </div>
                    </article>
                </section>
            </form>
        </div>

        <section class="table-generated-information" style="height: 100% !important">
            <ngx-datatable class="primary-ngx-datatable-styling enable-scroll-ngxdatable" [rows]="tableDataFiltered"
                           [headerHeight]="60"
                           [rowHeight]="55"
                           [columnMode]="'force'"
                           [scrollbarV]="true"
                           [scrollbarH]="true"
                           [selected]="selected"
                           #eiDataTableElement>
                           
                <ngx-datatable-column   [width]="30"
                           [sortable]="false"
                           [canAutoResize]="false"
                           [draggable]="false"
                           [resizeable]="false">
                    <ng-template   class="info-tile" ngx-datatable-header-template let-row="row">
                        <label class="datatable-checkbox parent-checkbox kpmg-checkbox">
                            <input type="checkbox" [disabled]="row && row.isAssigned" [checked]="masterCheckboxControl" (change)="selectMultiple()" /><span></span>
                        </label>
                    </ng-template>
                    <ng-template  ngx-datatable-cell-template let-row="row" let-isSelected="isSelected">
                        <label class="datatable-checkbox child-checkbox kpmg-checkbox">
                            <input type="checkbox" [disabled]="row && row.isAssigned" [checked]="isSelected || masterCheckboxControl" (change)="selectSingle(row, !isSelected)" /><span></span>
                        </label>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="150"  prop="displayName" name="Display Name">
                    <ng-template ngx-datatable-cell-template let-rowIndex ="rowIndex"  let-row="row"  let-value="value">
                        <input value="displayName" (blur)="editUser(row)" [id]="rowIndex" [ngClass]="editable[editableField]!=editable[rowIndex] ? 'editable-input' : 'show-edit'" class="editable-input" title="Edit" [(ngModel)]="row.displayName" [ngModelOptions]="{standalone: true}">
                        <span>
                            <button  class="link-button mr-2 editable-icon" (click)="editClick(rowIndex)">
                                <i class="fas fa-edit"></i>
                            </button>
                        </span>
                        </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="150" prop="firstName" name="First Name">
                    <ng-template ngx-datatable-cell-template let-i="rowIndex" let-value="value" let-row="row">
                        <input value="value" class="editable-input" (blur)="editUser(row)" (keyup)="updateDisplayName($event, row)" [id]="i + value + 'FirstName'" title="Edit" [(ngModel)]="row.firstName" [ngModelOptions]="{standalone: true}">
                        <button *ngIf="(row.firstName && row.firstName.length > 0) || row.errorMessage  !== ''" class="link-button mr-2 editable-icon" (click)="editFirstOrLastName(i,value+ 'FirstName')">
                            <i class="fas fa-edit"></i>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="150" prop="lastName" name="Last Name">
                    <ng-template ngx-datatable-cell-template let-j="rowIndex" let-value="value" let-row="row">
                        <input value="value" class="editable-input" (blur)="editUser(row)" (keyup)="updateDisplayName($event, row)" [id]="j + value+ 'LastName'" title="Edit" [(ngModel)]="row.lastName" [ngModelOptions]="{standalone: true}">
                        <button *ngIf="(row.lastName && row.lastName.length > 0) || row.errorMessage  !== ''" class="link-button mr-2 editable-icon" (click)="editFirstOrLastName(j,value+ 'LastName')">
                            <i class="fas fa-edit"></i>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="150" prop="userName" name="Sign-In Name">
                    <ng-template ngx-datatable-cell-template let-j="rowIndex" let-value="value" let-row="row">
                        <span *ngIf="row.errorMessage  === ''" >
                            {{row.userName}}
                        </span>
                        <input *ngIf="row.errorMessage  !== ''" value="value" class="editable-input" (blur)="editUser(row)"  [id]="j + value+ 'userName'" title="Edit" [(ngModel)]="row.userName" [ngModelOptions]="{standalone: true}">
                        <button *ngIf="row.errorMessage  !== ''"  class="link-button mr-2 editable-icon" (click)="editUserName(j,value+ 'userName')">
                            <i class="fas fa-edit"></i>
                        </button>
                    </ng-template>
               </ngx-datatable-column>
                <ngx-datatable-column [width]="150" prop="email" name="Email">
                    <ng-template ngx-datatable-cell-template let-j="rowIndex" let-value="value" let-row="row">
                        <span *ngIf="row.errorMessage  === ''" >
                            {{row.email}}
                        </span>
                        <input *ngIf="row.errorMessage  !== ''" value="value" class="editable-input" (blur)="editUser(row)"  [id]="j + value + 'email'" title="Edit" [(ngModel)]="row.email" [ngModelOptions]="{standalone: true}">
                        <button *ngIf="row.errorMessage  !== ''"  class="link-button mr-2 editable-icon" (click)="editUserName(j,value+ 'email')">
                            <i class="fas fa-edit"></i>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column [width]="100" prop="clientName" name="Client Name"> </ngx-datatable-column> -->
                <ngx-datatable-column [width]="50" name="Client Admin">
                    <ng-template let-column="column" ngx-datatable-header-template >
                        <div class="client-admin-circle-info" >
                            <span tooltip={{guidance}} offset="0" zIndex="20000" [options]="toolTipOptions" >
                             <i class="fas fa-info-circle"></i>
                            </span>
                            <span title="Client Admin">Client Admin</span>
                        </div>
                    </ng-template>
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <label *ngIf="row.errorMessage  === ''" class="datatable-checkbox child-checkbox kpmg-checkbox client-admin-checkbox">
                            <input type="checkbox" [disabled]="(row.userId === currentUserId)" (change)="roleCheckValue($event , row , 'clientadmin')" [checked]="getClientAdminRole(row)"/><span></span>
                        </label>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="350" *ngIf="isErrorMessage" prop="errorMessage" name="Message"></ngx-datatable-column>
            </ngx-datatable>
        </section>
    </main>
</div>

